import { Box, Button, Divider, Grid, Modal, Paper, Table, TableContainer, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import styled from "styled-components";
import { Upload } from "@aws-sdk/lib-storage"
import { S3Client, S3 } from "@aws-sdk/client-s3"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MultiPart from "./../shared/multipart/uploadParts"

const StyledModal = styled(Modal)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
})

const FileAttachementButton = (isView) => {
    const fileList = []
    const uploadFileList = []
    const [open, setOpen] = useState(false);
    console.log("isview", isView);
    console.log("uploadFileList", uploadFileList);
    console.log("fileList", fileList);
    // const upload = (file) =>{
    //     var file = file.target.files[0];


    //     const target ={Bucket:"application-1", Key:file.name, Body:file };
    //     const creds = {accessKeyId:"AKIA5GC47U55JF3IMDQT", secretAccessKey:"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"} ;

    //     try {
    //         console.log("In upload function")
    //         const parallelUploads3 = new Upload({
    //             client: new S3Client({region:"ap-south-1", credentials:creds}),
    //             leavePartsOnError:false,
    //             params:target,
    //         });

    //         parallelUploads3.on("httpUploadProgress", (progress)=>{
    //             console.log(progress);
    //         });

    //         parallelUploads3.done().then((data) => {

    //             console.log(data);
    //         });

    //         toast.success('File uploaded successfully!', {
    //             position: "top-center",
    //             autoClose: 5000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //             theme: "light",
    //             });

    //     } catch (error) {
    //         console.log("In Catch");
    //         console.log(error);
    //     }
    // }


    return (
        <>

            <Button onClick={(e) => setOpen(true)} variant="contained" color="success" sx={{ width: 120, borderRadius: 1 }}>Attachments </Button>
            <StyledModal open={open} onClose={(e) => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">

                <MultiPart isUpload={true} open={open} setOpen={setOpen} fileList={fileList} isDashboard={false} uploadFileList={uploadFileList} isView={isView}></MultiPart>
            </StyledModal>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />
        </>
    )
}

export default FileAttachementButton;
